import { useEffect, useState } from "react";

interface CopyPasteKeyState {
  isCopyPressed: boolean;
  isPastePressed: boolean;
  resetKeyPressed: () => void;
}

function isMacOS(): boolean {
  return navigator.userAgent?.toLowerCase().includes("mac") ?? false;
}

export function useHandleCopyPaste(): CopyPasteKeyState {
  const [isCopyPressed, setIsCopyPressed] = useState(false);
  const [isPastePressed, setIsPastePressed] = useState(false);

  function resetKeyPressed() {
    setIsCopyPressed(false);
    setIsPastePressed(false);
  }

  useEffect(() => {
    const isMac = isMacOS();

    const handleKeyDown = (e: KeyboardEvent) => {
      const ctrlOrCmd = isMac ? e.metaKey : e.ctrlKey;

      if (ctrlOrCmd && e.key.toLowerCase() === "c") {
        setIsCopyPressed(true);
      }

      if (ctrlOrCmd && e.key.toLowerCase() === "v") {
        setIsPastePressed(true);
      }
    };

    const handleKeyUp = (e: KeyboardEvent) => {
      const ctrlOrCmd = isMac ? e.metaKey : e.ctrlKey;

      if (!ctrlOrCmd || e.key.toLowerCase() === "c") {
        setIsCopyPressed(false);
      }

      if (!ctrlOrCmd || e.key.toLowerCase() === "v") {
        setIsPastePressed(false);
      }
    };

    globalThis.addEventListener("keydown", handleKeyDown);
    globalThis.addEventListener("keyup", handleKeyUp);

    return () => {
      globalThis.removeEventListener("keydown", handleKeyDown);
      globalThis.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  return { isCopyPressed, isPastePressed, resetKeyPressed };
}
